/* eslint-disable @typescript-eslint/no-explicit-any */
export const getHeader = (
  variation: string,
  isUserLoggedIn: boolean,
  offersData: any,
  offers: any,
  isMPOVar: boolean,
  mbeDynamicWorkflow?: boolean
) => {
  const offerMbeData = offersData || {};
  const titles = offersData?.hero;
  if (variation === 'active' && !isUserLoggedIn && isMPOVar) {
    return mbeDynamicWorkflow
      ? offers?.title
      : isUserLoggedIn
      ? titles?.authenticatedActiveTitle
      : isMPOVar
      ? offers?.title
      : titles?.anonymousActiveTitle;
  } else {
    return mbeDynamicWorkflow
      ? offerMbeData.title
      : isUserLoggedIn
      ? titles?.authenticatedInactiveTitle
      : titles?.anonymousInactiveTitle;
  }
};

export const getDescription = (
  variation: string,
  isUserLoggedIn: boolean,
  offersData: any,
  offers: any,
  isMPOVar: boolean,
  mbeDynamicWorkflow?: boolean
) => {
  const offerMbeData = offersData || {};
  const description = offersData?.hero || {};
  if (variation === 'active' && !isUserLoggedIn && isMPOVar) {
    return mbeDynamicWorkflow
      ? offers?.description
      : isUserLoggedIn
      ? description?.authenticatedActiveSubTitle
      : isMPOVar
      ? offers.description
      : description?.anonymousActiveSubTitle;
  } else {
    return mbeDynamicWorkflow
      ? offerMbeData?.description
      : isUserLoggedIn
      ? description?.authenticatedInactiveSubTitle
      : description?.anonymousInactiveSubTitle;
  }
};

export const getMBEWrapperClass = (isUserLoggedIn: boolean, utilityState: string) => {
  return !isUserLoggedIn && utilityState === 'active' ? '' : 'mbeMessage-wrapper';
};
